"use client"

import { StatusBadge } from "@/components/ui/status-badge"
import { OperationsTermTable } from "@/components/evaluation-dashboard/operations/operations-term-table"
import { dashboardSectionTitleClassName } from "@/components/dashboard-section-heading"
import { formatTermDateRange, termTimelineStatusMeta } from "@/lib/evaluation-term-utils"
import type { EvaluationTerm } from "@/lib/mock/evaluation-dashboard"
import type { EvaluationWorkQueueRow } from "@/lib/mock/evaluation-work-queue"

interface OperationsTermSectionProps {
  term: EvaluationTerm
  rows: EvaluationWorkQueueRow[]
}

export function OperationsTermSection({ term, rows }: OperationsTermSectionProps) {
  const timeline = termTimelineStatusMeta(term.timelinePosition)
  const dateRange = formatTermDateRange(term.startDate, term.endDate)
  const sectionId = `eval-operations-term-${term.id}`

  return (
    <section aria-labelledby={`${sectionId}-heading`} className="flex flex-col gap-4">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex min-w-0 flex-col gap-1">
          <div className="flex flex-wrap items-center gap-2">
            <h3 className={dashboardSectionTitleClassName} id={`${sectionId}-heading`}>
              {term.termName}
            </h3>
            <StatusBadge
              label={timeline.label}
              tone={timeline.tone}
              size="md"
              icon={timeline.icon}
            />
          </div>
          <p className="text-sm text-muted-foreground">
            {term.programName} · {term.academicYear} · {dateRange}
          </p>
        </div>
        <p className="text-sm tabular-nums text-muted-foreground">
          {term.courseOfferings === 1 ? "1 course" : `${term.courseOfferings} courses`}
        </p>
      </div>

      <OperationsTermTable termId={term.id} rows={rows} />
    </section>
  )
}
